import clsx from 'clsx';
import { type ForwardedRef, type PropsWithChildren, forwardRef } from 'react';
import type { Spacing } from './layout';
import { isDefined } from '@/utils/assertions';

export interface StackBoxProps {
  flex?: 'min' | 'expand';
  relative?: boolean;
  margin?: Spacing;
  padding?: Spacing;
  className?: string;
}

export const Box = forwardRef(
  (props: PropsWithChildren<StackBoxProps>, ref: ForwardedRef<HTMLDivElement>) => {
    const {
      flex = 'min',
      relative: isRelativePosition = false,
      margin,
      padding,
      className,
      children,
    } = props;

    const componentClassName = clsx(
      [
        'overflow-hidden',
        isDefined(margin) ? `m-${margin}` : undefined,
        isDefined(padding) ? `p-${padding}` : undefined,
        className,
      ],
      {
        'flex-grow-0 flex-shrink-0': flex === 'min',
        'flex-fill': flex === 'expand',
        'position-relative': isRelativePosition,
      },
    );

    return (
      <div ref={ref} className={componentClassName}>
        {children}
      </div>
    );
  },
);
